import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed0ec0b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "coupon-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "coupon-note text-gray-05 text-size-12" }, "\n      ＊ 新商品続々公開します\n    ", -1))

import { Gift } from "@/types/Gift";
import { useCustomRouter } from "@/utils/router";
import PointCouponCard from "@/components/organisms/mypage/PointCouponCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PointCouponList',
  props: {
    giftList: {}
  },
  setup(__props: any) {

const props = __props;



const { pushIgnoreError } = useCustomRouter();

const onClickExchangeGift = (gift: Gift) => {
  pushIgnoreError({
    name: "ConfirmExchangeCoupon",
    params: { giftId: `${gift.id}` }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.giftList, (gift) => {
        return (_openBlock(), _createElementBlock("li", {
          key: gift.id
        }, [
          _createVNode(PointCouponCard, {
            gift: gift,
            onClick: onClickExchangeGift
          }, null, 8, ["gift"])
        ]))
      }), 128))
    ]),
    _createTextVNode(),
    _hoisted_2
  ]))
}
}

})